import { composeFilter, Filter, FilterConfig } from 'src/utils/composeFilter.ts';
import { AttributesFilterInput, LocalesEnum } from 'src/generated/operations.ts';
import { MandatoryFilterInfo } from 'src/types/MandatoryFilterInfo.ts';

export function getFilterComposed(
    filterConfig: FilterConfig,
    filter: Filter | null,
    mandatoryFilter: MandatoryFilterInfo,
    currentLocale: LocalesEnum,
): [AttributesFilterInput, AttributesFilterInput] {
    return [
        composeFilter(
            [
                ...filterConfig,
                ...mandatoryFilter.config,
            ],
            {
                ...(filter || {}),
                ...mandatoryFilter.values,
            },
            currentLocale,
        ),
        composeFilter(
            mandatoryFilter.config,
            mandatoryFilter.values,
            currentLocale,
        ),
    ];
}
